var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComp2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_570_2272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4193 2.58333H18.8984V2.0625C18.8984 1.19896 18.1984 0.5 17.3359 0.5C16.4734 0.5 15.7734 1.19896 15.7734 2.0625V2.58333H9.52344V2.0625C9.52344 1.19896 8.82344 0.5 7.96094 0.5C7.09844 0.5 6.39844 1.19896 6.39844 2.0625V2.58333H5.8776C2.71927 2.58333 0.148438 5.15312 0.148438 8.3125V19.7708C0.148438 22.9302 2.71927 25.5 5.8776 25.5H19.4193C22.5776 25.5 25.1484 22.9302 25.1484 19.7708V8.3125C25.1484 5.15312 22.5776 2.58333 19.4193 2.58333ZM19.4193 22.375H5.8776C4.44115 22.375 3.27344 21.2062 3.27344 19.7708V9.875H22.0234V19.7708C22.0234 21.2062 20.8557 22.375 19.4193 22.375ZM10.5651 13.5208V15.6042C10.5651 16.4667 9.8651 17.1667 9.0026 17.1667H6.91927C6.05677 17.1667 5.35677 16.4667 5.35677 15.6042V13.5208C5.35677 12.6583 6.05677 11.9583 6.91927 11.9583H9.0026C9.8651 11.9583 10.5651 12.6583 10.5651 13.5208Z",
    fill: "#007AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_570_2272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.148438 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComp2);
export default __webpack_public_path__ + "static/media/Comp2.e299cd0346edacbab855c5a2f1358f95.svg";
export { ForwardRef as ReactComponent };